import { CLIENT_PORTAL_USER_STATUSES } from 'domain/shared/clientPortal';
import { ClientPortalTask, ClientPortalUser, ProjectClientPortalData } from './types';

export const clientPortalUsersMock: ClientPortalUser[] = [
  {
    id: '1',
    name: 'John Smith',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@mail.dev',
    status: CLIENT_PORTAL_USER_STATUSES.ACTIVE,
    invitedAt: '2026-06-01',
    lastLoginAt: '2026-06-15',
    accessUntil: '2026-12-31',
  },
  {
    id: '2',
    name: 'Sebastian King',
    firstName: 'Sebastian',
    lastName: 'King',
    email: 'important.someonenew@test.dev',
    status: CLIENT_PORTAL_USER_STATUSES.INVITED,
    invitedAt: '2026-06-10',
    lastLoginAt: undefined,
    accessUntil: '2026-12-31',
  },
  {
    id: '3',
    name: 'Important Person',
    firstName: 'Important',
    lastName: 'Person',
    email: 'vip@vipvip.com',
    status: CLIENT_PORTAL_USER_STATUSES.INACTIVE,
    invitedAt: '2026-06-10',
    lastLoginAt: '2026-07-01',
    accessUntil: '2026-12-31',
  },
  {
    id: '4',
    name: 'Someone New',
    firstName: 'Someone',
    lastName: 'New',
    email: 'someone.new@mail.dev',
    status: CLIENT_PORTAL_USER_STATUSES.FAILED,
    invitedAt: '2026-08-10',
    lastLoginAt: undefined,
    accessUntil: null,
  },
];
export type ClientPortalTaskFormData = Partial<ClientPortalTask> & {
  clients?: ClientPortalUser[];
};

export const mapClientPortalTaskPayload = ({ clients, ...payload }: ClientPortalTaskFormData) => payload;

export const getClientPortalVisibleUsers = (users: ClientPortalUser[]) =>
  users.filter(user => user.status !== CLIENT_PORTAL_USER_STATUSES.INACTIVE);

export const getClientPortalAssigneeOptions = (users: ClientPortalUser[]) =>
  users.reduce<Record<string, string>>((options, user) => {
    if (user.status !== CLIENT_PORTAL_USER_STATUSES.INACTIVE && user.status !== CLIENT_PORTAL_USER_STATUSES.FAILED) {
      options[user.id] = user.name || `${user.firstName} ${user.lastName}`.trim();
    }

    return options;
  }, {});

export const getClientPortalTaskById = (projectData: ProjectClientPortalData | undefined, taskId?: string) =>
  (projectData?.tasks || []).find(task => task.id === taskId);

export const getClientPortalTaskCommentsByTaskId = (
  projectData: ProjectClientPortalData | undefined,
  taskId?: string,
) => {
  if (!taskId) {
    return [];
  }

  return projectData?.taskComments?.[taskId] || [];
};

export const getClientPortalTaskActivitiesByTaskId = (
  projectData: ProjectClientPortalData | undefined,
  taskId?: string,
) => {
  if (!taskId) {
    return [];
  }

  return projectData?.taskActivities?.find(group => group.taskId === taskId)?.activities || [];
};
